import React from 'react'

function MsingiTab2() {
  return (
    <div>



<p>Quality education is currently not cheap. You need to know that as your children grow up, they can access world-class education no matter what the cost. As parents, we all want to secure our children’s futures. This starts with quality education. How does Msingi Poa help you invest?</p>

-You save for a minimum of 8 years and a maximum of 22 years.<br/><br/>
-The plan pays four lump sum benefits equivalent to 100% sum assured in the last four policy years. <br/><br/>
-In the last 3 years of the term, no premiums are payable.<br/><br/>
-After 3 years you can take policy loans of up to 80% of the value of your policy.<br/><br/>





    </div>
  )
}

export default MsingiTab2